import { writable } from 'svelte/store';
import httpRequest from './httpRequest';

const appsSubscription = writable([]);

const getApplications = async () => {

    let apps = await httpRequest.get('/app')

    appsSubscription.set(apps)

    return apps

}

const getOneApplication = async (uid) => {
    return await httpRequest.get(`/app/${uid}`)
}

const updateOneApplication = async (uid, data) => {
    return await httpRequest.post(`/app/${uid}`, data)
}

const createOneApplication = async (data) => {
    return await httpRequest.post(`/app/create`, data)
}

const deleteOneApplication = async (uid) => {
    return await httpRequest.delete_(`/app/${uid}`)
}

export default {
    appsSubscription,
    getApplications,
    getOneApplication,
    updateOneApplication,
    createOneApplication,
    deleteOneApplication
} 